import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { Observable } from 'rxjs';
import { DevExWindowComponent } from '../../../devExtreme/src/devExWindow/devExWindow.component';
import { ComponentStyle } from '../abcComponent.model';
import { AbcComponentService } from '../abcComponent.service';
import { IWindow, WindowStyle } from './abcWindow';

@Component({
  selector: 'abcWindow',
  template: '<ng-template #abcWindow></ng-template>',
  standalone: false,
})
export class AbcWindowComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input('width') attrWidth: string;
  private _height: string;
  @Input('height')
  get attrHeight(): string {
    return this._height;
  }
  set attrHeight(height) {
    this._height = height;
    if (this.componentRef?.attrHeight) {
      this.componentRef.attrHeight = height;
    }
  }
  @Input() resizable: string;
  private attrLabel: string;
  private _showLoader: boolean;
  @Input() attrlogo: any;
  @Input('component') attrComponent: any;
  @Input('reqData') attrReqData: any;
  @Input('id') attrId: string;
  @Input() maximizeButton: boolean;
  @Input() minimizeButton: boolean;
  @Input() minumizeDialogOption: number;
  private _position: string | object;
  @Input()
  get position(): string | object {
    if (!this._position) {
      if (this.componentRef) {
        this._position = this.componentRef.position;
      }
    }
    return this._position;
  }
  set position(position) {
    if (this.componentRef) {
      this.componentRef.position = position;
    }
    this._position = position;
  }
  @Input() shading: boolean;
  private attrStoreStateKey: string;
  @Input()
  set storeStateKey(storeStateKey: string) {
    this.componentRef.storeStateKey = storeStateKey;
  }
  @Input()
  get label(): string {
    return this.attrLabel;
  }
  set label(label: string) {
    this.componentRef.attrLabel = label;
    this.htmlAttributes.label = label;
    this.attrLabel = label;
  }
  @Input() _shadingColor;
  get shadingColor(): string {
    return this._shadingColor;
  }
  set shadingColor(shadingColor: string) {
    this.componentRef.shadingColor = shadingColor;
    this._shadingColor = shadingColor;
  }

  @Input()
  get showLoader(): boolean {
    return this._showLoader;
  }
  set showLoader(showLoader: boolean) {
    this.componentRef.showLoader = showLoader;
    this.htmlAttributes.showLoader = showLoader;
    this._showLoader = showLoader;
    setTimeout(() => {
      this.repaint();
    }, 0);
  }
  @Input() isInMobile: boolean;
  @Input() storeState: boolean;
  @ViewChild('abcWindow', { static: true, read: ViewContainerRef })
  viewContainerRef: ViewContainerRef;
  @Output() returnComponentInstance = new EventEmitter();
  @Output() onAfterOpened = new EventEmitter();
  @Output() onCloseClick = new EventEmitter();
  @Output() onAfterClosed = new EventEmitter();
  @Output() onClosing = new EventEmitter();
  @Output() onContentReady = new EventEmitter();

  @Output() onMinimizeClick = new EventEmitter();
  @Output() onMaximizeClick = new EventEmitter();

  style: ComponentStyle = ComponentStyle.DevExpress;
  get id(): string {
    return this.componentRef.attrId;
  }
  htmlAttributes: IWindow;
  eventListener = [];
  public allowDirectClose: boolean = true;
  private componentRef;

  constructor(
    private abcComponentService: AbcComponentService,
    iconRegistry: MatIconRegistry,
    sanitizer: DomSanitizer,
  ) {
    iconRegistry.addSvgIcon('restore', sanitizer.bypassSecurityTrustResourceUrl('assets/images/restore.svg'));

    // iconRegistry.addSvgIconLiteral('expand_more', sanitizer.bypassSecurityTrustHtml('<svg id="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 5 10"><defs><style>.expandMore{fill:#fff;}</style></defs><polygon class="expandMore" points="5 5 0 0 0 10 5 5"/></svg>'));
    iconRegistry.addSvgIconLiteral(
      'close',
      sanitizer.bypassSecurityTrustHtml(`<svg version="1.1" id="icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                viewBox="0 0 8 8" style="enable-background:new 0 0 8 8;" xml:space="preserve">
            <style type="text/css">
                .window_close{fill:#000000;}
            </style>
            <polygon class="window_close" points="8,0.5 7.5,0 4,3.5 0.5,0 0,0.5 3.5,4 0,7.5 0.5,8 4,4.5 7.5,8 8,7.5 4.5,4 "/>
            </svg>`),
    );
    iconRegistry.addSvgIconLiteral(
      'maximize',
      sanitizer.bypassSecurityTrustHtml(`<svg version="1.1" id="icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                viewBox="0 0 8 8" style="enable-background:new 0 0 8 8;" xml:space="preserve">
            <style type="text/css">
                .window_maximize{fill:#000000;}
            </style>
            <path class="window_maximize" d="M8,8H0V0h8V8z M0.8,7.3h6.5V0.8H0.8V7.3z"/>
            </svg>`),
    );
    iconRegistry.addSvgIconLiteral(
      'minimize',
      sanitizer.bypassSecurityTrustHtml(`<svg version="1.1" id="icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                viewBox="0 0 8 8" style="enable-background:new 0 0 8 8;" xml:space="preserve">
            <style type="text/css">
                .window_minimize{fill:#000000;}
            </style>
            <rect y="3.6" class="window_minimize" width="8" height="0.8"/>
            </svg>`),
    );
    iconRegistry.addSvgIconLiteral(
      'restore',
      sanitizer.bypassSecurityTrustHtml(`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 116.5 114.7"><defs>
            <style>.restore{fill:#000000;}</style></defs>
            <g id="Backstage_Menü" data-name="Backstage Menü">
            <g id="kopieren"><path class="restore" d="M104.8,121.7H5.5V22.5h99.3Zm-91.3-8H96.8V30.5H13.5Z" transform="translate(-5.5 -7)"/>
            <polygon class="restore" points="116.5 93.8 96.4 93.8 96.4 85.8 108.5 85.8 108.5 8 32.4 8 32.4 20.1 24.4 20.1 24.4 0 116.5 0 116.5 93.8"/>
            </g></g></svg>`),
    );
  }

  ngOnInit() {}

  ngAfterViewInit() {
    this.abcComponentService.addInstance(this);
  }

  ngOnDestroy(): void {
    this.eventListener = [];
    this.abcComponentService.removeInstance(this);
    this.componentRef?.ngOnDestroy();
  }
  createComponentInstance(): Observable<any> {
    const observable = new Observable((observer) => {
      switch (this.style) {
        case ComponentStyle.DevExpress: {
          const windowStyle: WindowStyle = this.htmlAttributes.setWindowStyle();
          this.componentRef = this.abcComponentService.loadComponent(
            DevExWindowComponent,
            this.viewContainerRef,
          ).componentRef.instance;
          this.componentRef.attrHeight = windowStyle.height;
          this.componentRef.attrWidth = windowStyle.width;
          this.componentRef.resizable = windowStyle.resizable ? windowStyle.resizable : false;
          this.componentRef.shading = windowStyle.shading ? windowStyle.shading : false;
          this.componentRef.shadingColor = windowStyle.shadingColor ? windowStyle.shadingColor : 'transparent';
          this.componentRef.position = windowStyle.position
            ? windowStyle.position
            : { my: 'center', at: 'center', of: window };
          this.componentRef.hideOnOutsideClick = this.htmlAttributes.hideOnOutsideClick;
          this.componentRef.attrLabel = this.htmlAttributes.label;
          this.componentRef.showLoader = this.htmlAttributes.showLoader;
          this.componentRef.attrlogo = this.htmlAttributes.logo;
          this.componentRef.maxHeight = windowStyle.maxHeight;
          this.componentRef.maxWidth = windowStyle.maxWidth;
          this.componentRef.minHeight = windowStyle.minHeight;
          this.componentRef.minWidth = windowStyle.minWidth;
          this.componentRef.minWidth = windowStyle.minWidth;
          this.componentRef.maximizeButton = this.htmlAttributes.maximizeButton;
          this.componentRef.minimizeButton = this.htmlAttributes.minimizeButton;
          this.componentRef.minumizeDialogOption = this.htmlAttributes.minumizeDialogOption;
          this.componentRef.attrId = this.htmlAttributes.id;
          this.componentRef.component = this.htmlAttributes.component;
          this.componentRef.isInMobile = this.htmlAttributes.isInMobile;
          this.componentRef.storeState = this.htmlAttributes.storeState;
          this.componentRef.storeStateKey = this.htmlAttributes.storeStateKey;
          this.componentRef.onAfterOpened.subscribe((event) => {
            this.afterOpened(event);
          });
          this.componentRef.onAfterClosed.subscribe((event) => {
            this.afterClosed(event);
          });
          this.componentRef.onCloseClick.subscribe(() => {
            this.closeDialog();
          });
          this.componentRef.onClosing.subscribe((event) => {
            this.onHiding(event);
          });
          this.componentRef.onContentReady.subscribe((event) => {
            this.onContentReadyHandler(event);
          });
          break;
        }
      }
      observer.next(this.componentRef);
    });

    return observable;
  }

  closeDialog() {
    if (this.allowDirectClose) {
      this.componentRef.closeDialog();
    } else {
      this.closeClick();
    }
  }

  minimizeDialog() {
    this.componentRef.minumizeDialog();
    this.onMinimizeClick.emit();
  }
  maximizeDialog() {
    this.componentRef.maximizeDialog();
    this.onMaximizeClick.emit();
  }

  setMaximizeButton(
    visible: boolean, //necessary to manipulate it manually sometimes
  ) {
    if (this.componentRef) {
      this.componentRef.maximizeButton = visible;
    }
  }

  setMinimizeButton(
    visible: boolean, //necessary sometimes to manipulate it manually
  ) {
    if (this.componentRef) {
      this.componentRef.minimizeButton = visible;
    }
  }

  public updateShading(enabled: boolean): void {
    if (this.componentRef) {
      this.componentRef.shading = enabled;
    }
  }

  closeClick() {
    this.onCloseClick.emit();
  }

  afterOpened(event: any) {
    this.onAfterOpened.next(event);
  }

  afterClosed(event: any) {
    this.onAfterClosed.next(event);
  }
  setWindowSize(width: string, height: string) {
    this.componentRef.componentInstance.setSize(width, height);
  }

  onHiding(event: any) {
    this.onClosing.emit(event);
  }

  private onContentReadyHandler(event: any) {
    this.onContentReady.emit(event);
  }

  repaint() {
    if (this.componentRef) {
      this.componentRef.repaint();
    }
  }
}
